import { connect } from "react-redux";
import UserArea from "./user-area";
import {
    getIsAuthenticated,
    actionCreators as userActionCreators,
} from "user/store";
import { actionCreators } from "page/calendar/store";
import {
    actionCreators as uiActionCreators,
    getShowLoginModal,
    getShowSaveDialog,
} from "ui/store";
import { ApplicationState } from "store";
import { getCalendar } from "page/calendar/store";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    UserArea_LoginRequired: getResource(state, {
        key: "UserArea_LoginRequired",
    }),
    UserArea_Menu: getResource(state, { key: "UserArea_Menu" }),
    isAuthenticated: getIsAuthenticated(state),
    calendar: getCalendar(state),
    showLoginModal: getShowLoginModal(state),
    showSaveDialog: getShowSaveDialog(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    ...userActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserArea);
